import React from 'react';
import BackButton from '../components/BackButton';

function FollowUpPage({handleFollowUp, handleComplete, handleBack}) {
  
  return (
    <div className='w-screen h-screen content-center'>
      <img className='absolute top-0 right-10' src={process.env.PUBLIC_URL + '/logo.png'} />
      <h1 className='text-2xl font-bold italic'>Would you want us to contact you for a follow-up?</h1>
      <div className='mt-5'>
        <button 
        className={`w-1/5 m-3 aspect-square bg-cover bg-no-repeat`}  
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/yes.png)`
        }} 
        onClick={handleFollowUp}></button>
        <button 
        className='w-1/5 m-3 aspect-square bg-cover bg-no-repeat' 
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/no.png)`
        }} 
        onClick={handleComplete}></button>
      </div>
      <BackButton handleBack={handleBack} />
    </div>
  );
}

export default FollowUpPage;